import axios from "axios";
import { Capacitor } from "@capacitor/core";

const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID || "com.taweelai.app";

export const isAppleSignInAvailable = () => Capacitor.getPlatform() === "ios";

export async function signInWithApple() {
  if (!isAppleSignInAvailable()) {
    throw new Error("Apple Sign In is only available on iOS.");
  }

  const { SignInWithApple } = await import("@capacitor-community/apple-sign-in");
  const result = await SignInWithApple.authorize({
    clientId: APPLE_CLIENT_ID,
    redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI || "https://taweelai.com/auth/callback",
    scopes: "email name"
  });

  const response = result?.response;
  if (!response?.identityToken) {
    throw new Error("Apple sign-in did not return an identity token.");
  }

  const authRes = await axios.post("/api/auth/apple", {
    identityToken: response.identityToken,
    authorizationCode: response.authorizationCode,
    givenName: response.givenName,
    familyName: response.familyName,
    email: response.email
  });

  return authRes.data;
}
